var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSankey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4248 21.9L13.0748 15.525L14.8998 13.7L21.2748 20.05L19.4248 21.9ZM4.7248 21.9L2.9248 20.05L10.2498 12.725L7.4248 9.9L6.8498 10.475L5.9998 9.65V11.5L5.2748 12.25L1.6748 8.65L2.3998 7.925H4.2998L3.3498 6.95L6.8498 3.5C7.16647 3.18333 7.51647 2.96667 7.89981 2.85C8.28314 2.73333 8.6998 2.675 9.1498 2.675C9.5998 2.675 10.0206 2.75833 10.4123 2.925C10.804 3.09167 11.1581 3.325 11.4748 3.625L8.6748 6.4L9.8748 7.575L9.2748 8.175L12.0248 10.95L15.1998 7.775C15.0831 7.59167 14.9873 7.35417 14.9123 7.0625C14.8373 6.77083 14.7998 6.475 14.7998 6.175C14.7998 5.225 15.1498 4.39583 15.8498 3.6875C16.5498 2.97917 17.3831 2.625 18.3498 2.625C18.6498 2.625 18.9165 2.6625 19.1498 2.7375C19.3831 2.8125 19.5831 2.91667 19.7498 3.05L17.6248 5.2L19.2998 6.875L21.4498 4.725C21.5998 4.90833 21.7081 5.12917 21.7748 5.3875C21.8415 5.64583 21.8748 5.925 21.8748 6.225C21.8748 7.19167 21.5248 8.025 20.8248 8.725C20.1248 9.425 19.2998 9.775 18.3498 9.775C18.0665 9.775 17.8206 9.75417 17.6123 9.7125C17.404 9.67083 17.2165 9.61667 17.0498 9.55L4.7248 21.9Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSankey);
export default __webpack_public_path__ + "static/media/sankey.057bf2bb94264fa2649e51178de29759.svg";
export { ForwardRef as ReactComponent };